import { Box, Chip, TextField } from '@material-ui/core'
import React, { useState } from 'react'

interface ITags {
  value: string
  onChange: (tags: string) => void
}

export const Tags = (props: ITags) => {
  const [text, setText] = useState('')

  const tags = props.value.split(',').filter(tag => tag !== '')

  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap'
      }}>
      {tags.map((tag, index) => (
        <Chip
          key={index}
          label={tag}
          onDelete={() => {
            props.onChange(tags.filter(t => t !== tag).join(','))
          }}
          style={{
            margin: 4
          }}
        />
      ))}
      <TextField
        value={text}
        variant='outlined'
        size='small'
        placeholder='Tags (comma separated)'
        fullWidth={tags.length === 0}
        onChange={e => {
          const input = e.target.value
          // Accept pasted comma-separated tags gracefully and filter out duplicates
          if (input.includes(',')) {
            const newTags = input
              .split(',')
              .map(tag => tag.trim())
              .filter(tag => tag !== '')
            const allTags = [...tags, ...newTags]
            const uniqueTags = Array.from(new Set(allTags))
            props.onChange(uniqueTags.join(','))
            setText('')
          } else {
            setText(input)
          }
        }}
        onBlur={() => {
          const newTags = text
            .split(',')
            .map(tag => tag.trim())
            .filter(tag => tag !== '')
          const allTags = [...tags, ...newTags]
          const uniqueTags = Array.from(new Set(allTags))
          props.onChange(uniqueTags.join(','))
          setText('')
        }}
      />
    </Box>
  )
}
